// 安装 Vue.js 插件。如果插件是一个对象，必须提供 install 方法。
// 如果插件是一个函数，它会被作为 install 方法。install 方法将被作为 Vue 的参数调用。
function install (Vue) {
  const filtersContext = require.context('./allFilters', true, /.js$/)
  filtersContext.keys().map(key => {
    let filter = filtersContext(key).default
    for (let prop in filter) {
      Vue.filter(prop, filter[prop])
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/filters/index.js